var map = {
	"./Graph.svg": "f0f2",
	"./device.svg": "ffb4",
	"./icon-1.svg": "17bd",
	"./icon-2.svg": "ce9e",
	"./icon-3.svg": "20ac",
	"./icon-4.svg": "5a8a",
	"./logo.svg": "d9b6",
	"./manufacturing.svg": "1335",
	"./solution.svg": "bdd5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";